import React from 'react';
import {useParams} from 'react-router-dom';
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";

const AdminDashboard = () => {

    return (
        <>
            <div className="flex flex-1">
                <div className='w-1/5'>
                    <AdminMenu path='./'/>
                </div>
                <div className='flex-grow w-4/5'>
                    <AdminHeader title='خوش آمدید'/>

                </div>
            </div>
        </>
    );
};

export default AdminDashboard;
